var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-route" }, [
    _vm.isReady && _vm.selectedProject
      ? _c("div", { staticClass: "project-module" }, [
          _c("header", { staticClass: "project-workspace-header" }, [
            _c(
              "div",
              { staticClass: "project-breadcrumb" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/projects" } },
                  [
                    _c("portal-icon", {
                      attrs: { name: "arrow-left", size: 17 }
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("projects.page-heading")) + " ")
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "project-heading-row" }, [
              _c("div", [
                _c("h1", [_vm._v(_vm._s(_vm.selectedProject.name))]),
                _c(
                  "div",
                  { staticClass: "project-heading-meta" },
                  [
                    _c(
                      "portal-status-pill",
                      {
                        attrs: {
                          background: _vm.selectedProject.active
                            ? "var(--v-success_10-base)"
                            : "var(--v-gray_20-base)",
                          color: _vm.selectedProject.active
                            ? "var(--v-success-base)"
                            : "var(--portal-muted)"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(_vm.projectStatusKey(_vm.selectedProject))
                            ) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "span",
                      [
                        _c("portal-icon", {
                          attrs: { name: "calendar-days", size: 15 }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("global.due")) +
                            " " +
                            _vm._s(
                              _vm.formatProjectDueDate(_vm.selectedProject) ||
                                _vm.$t("projects.no-due-date")
                            ) +
                            " "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm.isProjectSuspended(_vm.selectedProject)
              ? _c("p", { staticClass: "font-14", attrs: { role: "status" } }, [
                  _vm._v(_vm._s(_vm.$t("projects.lifecycle-read-only")))
                ])
              : _vm._e(),
            _c(
              "nav",
              {
                staticClass: "project-view-nav",
                attrs: { "aria-label": _vm.$t("projects.project") }
              },
              _vm._l(_vm.availableViews, function(page) {
                return _c(
                  "button",
                  {
                    key: page.value,
                    class: { active: _vm.view === page.value },
                    attrs: {
                      type: "button",
                      "aria-current": _vm.view === page.value ? "page" : null
                    },
                    on: {
                      click: function($event) {
                        return _vm.setView(page.value)
                      }
                    }
                  },
                  [
                    _c("portal-icon", { attrs: { name: page.icon, size: 17 } }),
                    _vm._v(" " + _vm._s(page.label) + " ")
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm.planningViews.includes(_vm.view)
            ? _c(
                "div",
                { staticClass: "project-toolbar" },
                [
                  _c(
                    "portal-filter-bar",
                    { attrs: { label: _vm.$t("global.filter") } },
                    [
                      _c("portal-search-field", {
                        attrs: {
                          label: _vm.$t("global.filter"),
                          placeholder: _vm.$t("global.filter"),
                          "clear-label": _vm.$t("global.clear")
                        },
                        model: {
                          value: _vm.taskFilter,
                          callback: function($$v) {
                            _vm.taskFilter = $$v
                          },
                          expression: "taskFilter"
                        }
                      }),
                      _c("portal-select-field", {
                        attrs: {
                          label: _vm.$t("projects.filter.status"),
                          options: _vm.taskStatusOptions
                        },
                        model: {
                          value: _vm.taskStatus,
                          callback: function($$v) {
                            _vm.taskStatus = $$v
                          },
                          expression: "taskStatus"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "project-container show-scrollbar" },
            [
              _vm.view === "overview"
                ? _c(
                    "section",
                    { staticClass: "project-detail-shell" },
                    [
                      _c("project", {
                        key: _vm.selectedProject.id,
                        attrs: {
                          project: _vm.selectedProject,
                          "status-list": _vm.getStatusList(
                            _vm.selectedProject.projectTypeId
                          ),
                          "compact-header": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "tasks" && _vm.canManageProject
                ? _c(
                    "div",
                    [
                      _c("project-kanban", {
                        attrs: {
                          "read-only": _vm.isProjectSuspended(
                            _vm.selectedProject
                          ),
                          "assignable-users": _vm.assignableUsers,
                          "has-full-access-projects":
                            _vm.canEditProject(_vm.selectedProject) &&
                            !_vm.selectedProject.portalAccessAssignedOnly,
                          deliverables: _vm.filteredDeliverables,
                          "is-collaborator": true,
                          columns: _vm.activeProjectType.statusList,
                          "header-height": _vm.headerHeight
                        },
                        on: {
                          "edit-deliverable": function($event) {
                            return _vm.editDeliverable($event)
                          },
                          "update-kanban-props": function($event) {
                            return _vm.updateKanbanProperties($event)
                          },
                          "add-deliverable": function($event) {
                            return _vm.addDeliverable($event)
                          },
                          "add-subtask": function($event) {
                            return _vm.createSubtask($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "list" && _vm.canManageProject
                ? _c("project-task-table", {
                    attrs: {
                      deliverables: _vm.filteredDeliverables,
                      "status-list": _vm.activeProjectType.statusList,
                      "assignable-users": _vm.assignableUsers
                    },
                    on: {
                      "open-deliverable": function($event) {
                        return _vm.editDeliverable($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.view === "calendar" && _vm.canManageProject
                ? _c(
                    "div",
                    { staticClass: "planning-surface show-scrollbar" },
                    [
                      _c("project-calendar", {
                        attrs: {
                          projects: [_vm.selectedProject],
                          deliverables: _vm.filteredDeliverables,
                          "status-list": _vm.activeProjectType.statusList
                        },
                        on: {
                          "edit-deliverable": function($event) {
                            return _vm.editDeliverable($event)
                          },
                          "update-due-date": function($event) {
                            return _vm.datesUpdated($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "time" && _vm.timeEnabled
                ? _c("project-time", {
                    attrs: { "project-id": _vm.selectedProject.id }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : !_vm.isReady
      ? _c(
          "div",
          { staticClass: "project-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", size: 38, width: 3, color: "primary" }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "project-loading" },
          [
            _c("div", [_vm._v(_vm._s(_vm.$t("timetrack.no-projects")))]),
            _c("router-link", { attrs: { to: "/projects" } }, [
              _vm._v(_vm._s(_vm.$t("projects.page-heading")))
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }